<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <h3 class="mb-0">
                        {{ $tc('message.subscribers', 1) }}
                    </h3>
                </div>
            </div>

            
                <div class="">
                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ fullName }}
                        </h3>
                    </div>
                    <div class="container-fluid">
                        <div class="list-group list-group-flush">
                            <div class="container-fluid">
                                <div class="row">
                                <div class="col-md-6 col-sm-6">
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.lastName') }}:

                                            <span class="font-weight-bold">
                                    {{ getValue(mSubscriberUserInformation.nom) }}
                                </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.firstName') }}:

                                            <span class="font-weight-bold">
                                    {{ mSubscriberUserInformation.prenom != null ? getValue(mSubscriberUserInformation.prenom) : " "}}
                                </span>
                                        </div>
                                    </div>

                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.email') }}:

                                            <span class="font-weight-bold">
                                    {{ getValue(mSubscriberUserInformation.email) }}
                                </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.phoneNumber') }}:

                                            <span class="font-weight-bold">
                                    {{ getValue(mSubscriberUserInformation.telephone) }}
                                </span>
                                        </div>
                                    </div>
                            <!-- </b-row>
                            <b-row> -->
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.gender') }}:

                                            <span class="font-weight-bold">
                                    {{ mSubscriber.sexe }}
                                </span>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="list-group-item">
                                            {{ $t('message.dob') }}:

                                            <span class="font-weight-bold">
                                    {{ formattedDate(mSubscriber.date_de_naissance) }}
                                </span>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-sm-12">
                                <div>
                                    <div class="list-group-item">
                                        {{ $t('message.nationality') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mSubscriberUserInformation.nationalite) }}
                            </span>
                                    </div>
                                </div>
                                <div>
                                    <div class="list-group-item">
                                        {{ $tc('message.countries', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mSubscriberUserInformation.pays) }}
                            </span>
                                    </div>
                                </div>
                                <div>
                                    <div class="list-group-item">
                                        {{ $tc('message.cities', 1) }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mSubscriberUserInformation.ville) }}
                            </span>
                                    </div>
                                </div>

                                <div>
                                    <div class="list-group-item">
                                        {{ $t('message.street') }}:

                                        <span class="font-weight-bold">
                                             {{ getValue(mSubscriberUserInformation.quartier) }}
                            </span>
                                    </div>
                                </div>

                                <div>
                                    <div class="list-group-item">
                                        {{ $t('message.zipCode') }}:

                                        <span class="font-weight-bold">
                                             {{ getValue(mSubscriberUserInformation.code_postal) }}
                            </span>
                                    </div>
                                </div>


                                <div>
                                    <div class="list-group-item">
                                        {{ $tc('message.address') }}:

                                        <span class="font-weight-bold">
                                {{ getValue(mSubscriberUserInformation.adresse) }}
                            </span>
                                    </div>
                                </div>
                                </div>
                                </div>
                            </div>
                           
                        </div>
                    </div>

                    <div class="card-body p-1em">
                        <h3 class="card-title text-center mb-0">
                            {{ $tc('message.patients', 2) }}
                        </h3>
                    </div>

                    <ol>
                        <!-- <li> -->
                            <table >
                                <tr>
                                    <td><b>Noms et prénoms</b></td>
                                    <td><b>Décédé</b></td>
                                </tr>
                                <tr v-for="patient in mPatients" :key="patient.id">
                                    <td>{{ patient.nom }}</td>
                                    <td v-if="patient.decede == 'non'">
                                        <h2><b-badge variant="success">{{ patient.decede }}</b-badge></h2>
                                    </td>
                                    <td v-else>
                                        <b-badge variant="danger">{{ patient.decede }}</b-badge>
                                    </td>
                                </tr>
                            </table>
                            <!-- <span class="font-weight-bold">
                                
                                
                                <p></p> 
                            </span> -->
                        <!-- </li> -->
                    </ol>

                    <b-container>
                        <b-row class="justify-content-sm-center" v-if="can || hasAssistante || ( hasPraticienRole || hasMedecinControleRole || hasAssistante)">
                            <div class="card-footer text-right" >
                                <b-button variant="primary" @click="updateSubscriber">
                                    {{ $t('message.edit') }}
                                </b-button>

                                <b-button v-b-modal.delete-modal variant="danger">
                                    {{ $t('message.delete') }}
                                </b-button>
                            </div>
                        </b-row>
                    </b-container>

                    <b-modal
                            id="delete-modal"
                            size="sm"
                            header-bg-variant="danger"
                            header-text-variant="light"
                            :title="$t('message.delete') + ' ' + $tc('message.subscribers', 1)"
                            hide-footer
                    >
                        <div class="d-block text-center">
                            <h3>{{ $t('message.delete') }} {{ mSubscriberUserInformation.nom }}?</h3>
                        </div>

                        <div class="d-block float-right">
                            <b-button variant="danger" @click="deleteSubscriber">
                                {{ $t('message.delete') }}
                            </b-button>

                            <b-button variant="secondary" @click="$bvModal.hide('delete-modal')">
                                {{ $t('message.cancel') }}
                            </b-button>
                        </div>
                    </b-modal>
                </div>
         
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import _ from 'lodash';
    import moment from 'moment';

    export default {
        name: "Subscriber",

        computed: {
            ...mapGetters(["subscriber",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante']),
            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasAssistante;
            },

            mSubscriber: function() {
                return this.subscriber;
            },

            mPatients: function() {
                let patients = this.mSubscriber.patients;
                let pArray = [];

                _.forEach(patients, function(patient) {
                    let p = {};
                    if(patient != null){
                        let user = patient.user;

                        p.id = user.id;
                        let prenom  = user.prenom != null ? user.prenom : "";
                        prenom =  prenom.toLowerCase();
                        p.nom = (user.nom).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);
                        p.decede = user.decede;
                        pArray.push(p);
                    }
                    
                });

                return pArray;
            },

            mSubscriberUserInformation:function(){
                if (typeof this.mSubscriber.user == 'object'){
                    return this.mSubscriber.user;
                }
                return [];
            },

            fullName:function () {
                let prenom  = this.mSubscriberUserInformation.prenom != null ? this.mSubscriberUserInformation.prenom : "";
                prenom =  prenom.toLowerCase();
                return (this.getValue(this.mSubscriberUserInformation.nom)).toUpperCase() + " "+ prenom.charAt(0).toUpperCase() + prenom.substring(1);

            }


        },

        data() {
            return {
                subscriber_id: this.$route.params.subscriber
            }
        },

        methods: {

            getSubscriber() {
                let args = {
                    subscriber: this.subscriber_id
                };

                this.$store.dispatch("getSubscriber", { args });
            },

            formattedDate(date) {

                return _.isNull(date) ? '': moment(date).format('DD-MM-YYYY');
            },

            updateSubscriber() {
                this.$router.push({ name: 'edit-subscriber', params: { subscriber: this.subscriber_id } });
            },

            deleteSubscriber() {
                let self = this;
                let args = {
                    subscriber: this.subscriber_id
                };

                let successMessage = this.$i18n.t('message.subscriberDeleted');
                let errorMessages = {
                    generic: this.$i18n.t('message.genericError'),
                    error: this.$i18n.t('message.error')
                };

                this.$store.dispatch('deleteSubscriber', { args, index: self.subscriber_id, successMessage, errorMessages }).then(() => {
                    self.$bvModal.hide('delete-modal');
                    this.$router.back();

                });
            },

            getValue(item){
                if (typeof item != "undefined"){
                    return item;
                }else{
                    return "";
                }
            }
        },

        mounted() {
            this.getSubscriber();
        }
    }
</script>

<style scoped>

</style>